import {
  FormGroup,
  FormControlLabel,
  Switch,
  TextField,
  Grid,
  CircularProgress,
  ButtonBase,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import type { StyledComponentProps } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { listConnects, saveNewConnect } from 'store/Orbita/Connect/actions';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { run } from 'validations/ruleRunner';

import Validations from './validations';
import { ConnectPlatform } from '../../constants';
import styles from '../../styles';

import type { DispatchProp } from 'react-redux';

const { RD_STATION, ACTIVE_CAMPAIGN, LEAD_LOVERS } = ConnectPlatform;

enum EStep {
  PLATFORM = 0,
  ACCOUNT = 1,
  CONNECT = 2,
  LOADING = 3,
  DONE = 4,
}
interface IProps extends DispatchProp<any>, StyledComponentProps {
  newConnect: any;
  onSave: any;
  step: any;
  handleClose: any;
  autoresponders: any;
  modal: any;
}

class NewConnect extends React.Component<IProps, any> {
  state = {
    activeStep: EStep.PLATFORM,
    skipped: new Set(),
    canNext: false,
    //validations
    showErrors: false,
    isSaving: false,
    validationErrors: [] as any,
  };

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  handleNext = () => {
    this.props.dispatch({ type: 'NEXT_STEP' });
  };

  handleBack = () => {
    this.props.dispatch({ type: 'PREVIOUS_STEP' });
  };

  handleChange = (field: any, value: any) => {
    let { newConnect } = this.props;
    newConnect[field] = value;
    this.props.dispatch({ type: 'CHANGE_NEW_CONNECT', newConnect });
  };

  componentDidUpdate(prevProps: any) {
    const { newConnect } = this.props;
    if (newConnect !== prevProps.newConnect) {
      let newState = { ...this.state };
      newState.validationErrors = run(newConnect, Validations);
      this.setState(newState);
      this.isValidToNextStep();
    }
  }

  isValidToNextStep = () => {
    const { newConnect, step } = this.props;
    switch (step) {
      case EStep.PLATFORM:
        return newConnect.description ? true : false;
      case EStep.ACCOUNT:
        return newConnect.autoresponder ? true : false;
      case EStep.CONNECT:
        let isValid = true;
        newConnect.autoresponder &&
          newConnect.autoresponder.parameters &&
          Array.isArray(newConnect.autoresponder.parameters.parametros) &&
          newConnect.autoresponder.parameters.parametros.map((param: any) => {
            isValid = newConnect[param.nome] ? isValid : false;
            return isValid;
          });
        return isValid;
      default:
        return false;
    }
  };

  closeModal = () => {
    this.props.dispatch({ type: 'CLOSE_MODAL_NEW_CONNECT' });
    this.props.dispatch({ type: 'RESET_NEW_CONNECT' });
    this.props.dispatch({ type: 'RESET_STEP' });
  };

  saveNewConnect = async () => {
    try {
      this.handleNext();
      let newConnect = Object.assign({}, this.props.newConnect);
      newConnect.autoresponder_id = newConnect.autoresponder.id;
      let fields = {};
      newConnect.autoresponder &&
        newConnect.autoresponder.parameters &&
        Array.isArray(newConnect.autoresponder.parameters.parametros) &&
        newConnect.autoresponder.parameters.parametros.map((param: any) => {
          fields[param.nome] = newConnect[param.nome];
          delete newConnect[param.nome];
          return false;
        });
      newConnect.fields = fields;
      delete newConnect.autoresponder;
      await this.props.dispatch(saveNewConnect(newConnect));
      if (this.props.onSave) {
        this.props.onSave();
      }
      this.handleNext();
    } catch (error) {
      toast.error(error);
      this.handleBack();
    }
  };

  componentDidMount() {
    this.props.dispatch(listConnects());
  }

  redirectUrl = (url: any) => {
    return (window.location.href = url);
  };

  paramType = (param: any, newConnect: any): any => {
    localStorage.setItem('connect-description', this.props.newConnect.description);
    if (param.tipo === 'field') {
      return (
        <TextField
          key={`parameter-${param.nome}`}
          id={param.nome}
          label={param.label}
          fullWidth
          onChange={(e: any) => this.handleChange(param.nome, e.target.value)}
          value={newConnect[param.nome]}
          margin='normal'
          InputProps={{
            disableUnderline: true,
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      );
    }

    if (param.tipo === 'botao') {
      let urlButton = param.botao_url;
      return (
        <Button variant='contained' color='secondary' onClick={() => this.redirectUrl(`${urlButton}`)}>
          {param.botao_titulo}
        </Button>
      );
    }
  };

  render() {
    const steps = ['Descrição', 'Plataforma', 'Dados de configuração'];
    const { newConnect, step, autoresponders, classes } = this.props;
    return (
      <Dialog open={this.props.modal} onClose={this.props.handleClose} scroll='paper' fullWidth maxWidth='sm'>
        <DialogTitle>
          <Typography variant='h6' style={{ color: '#192542', textAlign: 'center' }}>
            Cadastro de Integração
          </Typography>
          <Stepper activeStep={step} alternativeLabel>
            <Step>
              <StepLabel>Descrição</StepLabel>
            </Step>
            <Step>
              <StepLabel>Plataforma</StepLabel>
            </Step>
            <Step>
              <StepLabel>Dados de configuração</StepLabel>
            </Step>
          </Stepper>
        </DialogTitle>
        <DialogContent>
          <>
            {step === EStep.PLATFORM && (
              <FormGroup row>
                <FormControlLabel
                  control={<Switch checked={newConnect.active} onChange={(e: any) => this.handleChange('active', e.target.checked)} value='active' />}
                  label={newConnect.active ? 'Ativo' : 'Inativo'}
                />
                <TextField
                  multiline={true}
                  fullWidth={true}
                  label={'Descrição'}
                  InputProps={{ rows: 3, disableUnderline: true }}
                  InputLabelProps={{ shrink: true }}
                  placeholder='Digite a descrição do connect'
                  value={newConnect.description}
                  helperText={this.isValid('description') ? this.errorFor('description') : null}
                  error={this.isValid('description')}
                  onChange={(e: any) => this.handleChange('description', e.target.value)}
                />
              </FormGroup>
            )}

            {step === EStep.ACCOUNT && (
              <Grid container>
                {autoresponders &&
                  Array.isArray(autoresponders) &&
                  autoresponders
                    .filter((a) => a.id !== RD_STATION)
                    .map((item: any) => (
                      <Grid key={item.id} xs={3} item>
                        <ListResponders item={item} newConnect={newConnect} handleChange={this.handleChange} classes={classes} />
                      </Grid>
                    ))}
              </Grid>
            )}

            {step === EStep.CONNECT && (
              <>
                <Grid xs={12} justify='center' container>
                  <Grid xs={6} style={{ textAlign: 'center' }} item>
                    <div className={classes.demo}>
                      <span
                        className={classes.demoImageSrc}
                        style={{
                          backgroundImage: `url(${newConnect.autoresponder?.image ?? null})`,
                        }}
                      />
                    </div>
                  </Grid>
                </Grid>
                <Grid xs={12} spacing={2} container>
                  {Array.isArray(newConnect.autoresponder?.parameters?.parametros) &&
                    newConnect.autoresponder.parameters.parametros.map((param: any) => (
                      <Grid xs={6} item key={param}>
                        {this.paramType(param, newConnect)}
                      </Grid>
                    ))}
                </Grid>
              </>
            )}

            {step === EStep.LOADING && (
              <Grid xs={12} style={{ textAlign: 'center' }}>
                <CircularProgress />
              </Grid>
            )}

            {step === EStep.DONE && (
              <Grid xs={12} style={{ textAlign: 'center' }}>
                <span> Connect salvo com sucesso. </span>
                <div className='m32' />
                <Button style={{ float: 'right' }} variant='contained' onClick={this.closeModal} color='primary'>
                  Fechar
                </Button>
              </Grid>
            )}
          </>
        </DialogContent>
        <DialogActions>
          <Grid container justify='space-between' spacing={2}>
            <Grid item xs={12} md={6}>
              {step < EStep.DONE && <Button onClick={this.closeModal}>Cancelar</Button>}
            </Grid>
            <Grid item xs={12} md={6} style={{ textAlign: 'right' }}>
              {step !== EStep.PLATFORM && step < EStep.LOADING && (
                <Button onClick={this.handleBack} color='primary' variant='contained' style={{ marginRight: '5px' }}>
                  <Icon fontSize='inherit'>chevron_left</Icon>Voltar
                </Button>
              )}
              {step < EStep.LOADING && (
                <Button
                  variant='contained'
                  color='secondary'
                  onClick={step === steps.length - 1 ? this.saveNewConnect : this.handleNext}
                  disabled={!this.isValidToNextStep()}
                >
                  {step === steps.length - 1 ? 'Salvar' : 'Avançar'}
                  {step !== steps.length - 1 && <Icon fontSize='inherit'>chevron_right</Icon>}
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    newConnect: state.components.Connect.newConnect,
    step: state.components.Connect.step,
    modal: state.components.Connect.modalNewConnect,
    autoresponders: state.orbita.Connect.listConnect,
  };
}

const ListResponders = ({
  item,
  newConnect,
  classes,
  handleChange,
}: {
  item: any;
  newConnect: any;
  classes: any;
  handleChange: (name: string, item: any) => void;
}) => {
  const isBeta = eduzzAccountsService.verifyUserHasBetaModule('new_connect');
  const betaProviders = [ACTIVE_CAMPAIGN, LEAD_LOVERS];
  const hasProviderInBeta = betaProviders.includes(item.id);

  if (isBeta && hasProviderInBeta) {
    return (
      <Tooltip
        key={item.name}
        placement='top'
        title={'Esta plataforma foi migrada para a nova versão do Connect Eduzz, acesse o novo connect para configurá-lo'}
      >
        <span className={classes.spanButton}>
          <ButtonBase
            focusRipple
            className={classes.image}
            focusVisibleClassName={classes.focusVisible}
            style={{
              width: '100%',
            }}
            onClick={() => handleChange('autoresponder', item)}
            disabled={hasProviderInBeta}
          >
            <span
              className={classes.imageSrc}
              style={{
                backgroundImage: `url(${item.image})`,
              }}
            />
            <span className={newConnect.autoresponder?.name === item.name ? `${classes.imageBackdrop} --active` : classes.imageBackdrop} />
            <span className={classes.imageButton}></span>
          </ButtonBase>
        </span>
      </Tooltip>
    );
  }

  return (
    <span className={classes.spanButton}>
      <ButtonBase
        focusRipple
        className={classes.image}
        focusVisibleClassName={classes.focusVisible}
        style={{
          width: '100%',
        }}
        onClick={() => handleChange('autoresponder', item)}
      >
        <span
          className={classes.imageSrc}
          style={{
            backgroundImage: `url(${item.image})`,
          }}
        />
        <span className={newConnect.autoresponder?.name === item.name ? `${classes.imageBackdrop} --active` : classes.imageBackdrop} />
        <span className={classes.imageButton}></span>
      </ButtonBase>
    </span>
  );
};

export default connect(mapStateToProps)(styles(NewConnect));
